import { init } from "@amplitude/engagement-browser";

import { CONFIG } from "config";
import { DEVICE_ID, USER } from "data/ss-data-store";

import { getCookie } from "./cookies";

let initialized = false;

export function initAmplitude() {
  if (initialized) return;
  if (!CONFIG.AMPLITUDE_API_KEY) return;
  if (getCookie("DoNotTrack") === "true") return;
  initialized = true;

  init(CONFIG.AMPLITUDE_API_KEY, { serverZone: "US" });
  // `integrations` is required by boot(); a noop is acceptable for engagement-only.
  void window.engagement
    .boot({
      user: { device_id: DEVICE_ID, user_id: USER?.userId },
      integrations: [{ track: () => {} }],
    })
    .catch(() => {});
}
